import { render, staticRenderFns } from "./QuestionMixingValve.vue?vue&type=template&id=4f5b68db&"
import script from "./QuestionMixingValve.vue?vue&type=script&lang=js&"
export * from "./QuestionMixingValve.vue?vue&type=script&lang=js&"
import style0 from "./QuestionMixingValve.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports